var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-view view"},[(_vm.product)?_c('div',{staticClass:"container box has-no-border"},[_c('ShopProduct')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }